import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';
import store from 'src/store';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    TABLE_ANNOTATOR_GENERATE_ANNOTATIONS_REQUEST,
    generateAnnotationsSuccess,
    generateAnnotationsFailure,
} from 'src/store/actions/tableAnnotator/tableAnnotatorDb.actions';

import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(sessionId, payload) {
    const url = '/tableAnnotator/generateAnnotations';

    // note: hits the worker-server directly; not the api-server.
    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            genBatchId: payload.genBatchId,
            annotationType: payload.annotationType,
            classificationCode: payload.classificationCode,
            dataRows: payload.dataRows,
            fieldsRow: payload.fieldsRow,
            globalFields: payload.globalFields,
            groupingMethod: payload.groupingMethod,
            groupsRow: payload.groupsRow,
            tableId: payload.tableId,
        },
        headers: {
            sessionid: sessionId,
        },
    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga(action) {

    const globalState = store.getState().global;
    const sessionId = globalState.sessionId;


    try {
        const resp = yield call(callApi, sessionId, action.payload);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(generateAnnotationsSuccess(resp.payload));

    } catch (error) {
        yield put(generateAnnotationsFailure(error));
        handleSagaErrors(error);
    }
}

export default function* createRequestMonitor() {
    yield takeLatest(TABLE_ANNOTATOR_GENERATE_ANNOTATIONS_REQUEST, createRequestSaga);
}
